// ================================================= /
// ======   Card Deck JS   ========================= /
// ================================================= /

/* global jQuery */

import { debounce } from 'throttle-debounce';
import gsap from 'gsap';

import animation from './animation';
import subnav from './subnav';
import slider from './slider';

/**
 * Class for controlling the card deck element
 */
class DispatchSkinCardDeck {

	/**
	 * Constructs the class and sets up instance variables.
	 */
	constructor() {

		this.selector = '.js-card-deck';
		this.innerSelector = `${this.selector}__inner`;
		this.cardSelector = `${this.selector}__card`;
		this.oddActiveClass = 'has-odd-active';

		this.eventNamespace = 'dispatchSkinCardDeck';
		this.resizeDebounce = 100;
		this.animationDuration = 0.66666666666;
		this.animationDelay = 0.1;

		this.cardDecks = [];
	}

	/**
	 * Initializes the class, sets up events.
	 */
	initialize() {

		this.cardDecks = jQuery( this.selector );

		if ( this.cardDecks.length ) {

			this.events();
		}
	}

	/**
	 * Wires up events
	 */
	events() {

		this.eventDelegationParent = jQuery( '.site' );

		// Slider hooks

		slider.addHook(
			'beforeTouch',
			this.selector,
			() => false
		);
		slider.addHook(
			'afterSetState',
			this.selector,
			this.handleSlideChange.bind( this )
		);

		// Animation hooks

		animation.addHook(
			this.selector,
			this.resolveAnimation.bind( this )
		);
		animation.addHook(
			this.selector,
			this.resetAnimation.bind( this ),
			false
		);

		// Resize
		jQuery( window ).on(
			`resize.${this.eventNamespace}`,
			debounce(
				this.resizeDebounce,
				this.handleResize.bind( this )
			)
		);
	}

	/**
	 * Handles slide change.
	 */
	handleSlideChange( cardDeck ) {

		const cards = cardDeck.find( this.cardSelector );
		const index = slider.getActiveIndex( cardDeck );

		cards.eq( index ).removeClass( slider.comingClass );

		this.resize( cardDeck );

		return false;
	}

	/**
	 * Handles resize.
	 */
	handleResize() {

		this.cardDecks.each(
			function( cardDeck ) {
				this.resize( jQuery( cardDeck ) );
			}.bind( this )
		);
	}

	/**
	 * Animation callbacks
	 */
	resolveAnimation( cardDeck ) {

		slider.changeSlide( cardDeck, 0 );
	}
	resetAnimation( cardDeck ) {

	}

	/**
	 * Resizes a card deck.
	 */
	resize( cardDeck, animate = true ) {

		const inner = cardDeck.find( this.innerSelector );
		const toHeight = cardDeck.find( this.cardSelector )
			.eq( slider.getActiveIndex( cardDeck ) )
			.outerHeight();

		const animationProps = {
			duration: this.animationDuration,
			delay: this.animationDelay,
			height: toHeight,
			onComplete: function() {
				subnav.reset();
				animation.setSectionOffsets();
			}
		};

		if ( animate ) {
			gsap.to(
				inner,
				animationProps
			);
		}

		else {
			gsap.set(
				inner,
				animationProps
			);
		}
	}

}

const cardDeck = new DispatchSkinCardDeck();
export default cardDeck;



// WEBPACK FOOTER //
// ./src/js/inc/card-deck.js